import React from "react";

export default function Layout({ children }) {
  return (
    <main className="flex-grow w-full">
      {children}
    </main>
  );
}
